@if (!loading) {
  <div class="card card-borders m-3 p-3">
    <h6>{{ "RULES" | translate }}</h6>
    @for (rule of rules; track rule; let i = $index) {
      <div class="mb-3">
        <!-- SUBJECT -->
        <div class="mb-3">
          <label class="form-label">{{ "SUBJECT" | translate }}</label>
          <input
            class="form-control form-control-sm"
            [(ngModel)]="rule.subject"
            />
          </div>
          <!-- TEXT -->
          <div class="mb-3">
            <label class="form-label">{{ "TEXT" | translate }}</label>
            <input
              class="form-control form-control-sm"
              [(ngModel)]="rule.description"
              />
            </div>
          </div>
        }
        <div class="form-group mb-3">
          @if (rules.length > 0) {
            <button class="btn btn-primary mr-2" (click)="save()">
              <span class="fa fa-floppy-disk"></span>
              {{ "SAVE" | translate }}
            </button>
          }
          <button class="btn btn-outline-primary btn-sm" (click)="addRule()">
            {{ "ADD_RULE" | translate }}
          </button>
        </div>
        <hr>
          <h6>{{ "AREAS" | translate }}</h6>
          @for (area of areas; track area; let i = $index) {
            <div class="mb-4">
              <!-- HEADER -->
              <div class="row mb-1">
                <div class="col-sm-4"><label>{{ "AREA_INFO" | translate }}</label></div>
                <div class="col-sm-3"><label>{{ "PHONE_NUMBER" | translate }}</label></div>
                <div class="col-sm-2"><label>{{ "TIMES" | translate }}</label></div>
                <div class="col-sm-1"></div>
              </div>
              <!-- ROWS -->
              @for (row of area.rows; track row; let j = $index) {
                <div
                  class="row mb-2 align-items-center">
                  <!-- AREA -->
                  <div class="col-sm-4">
                    @if (j === 0) {
                      <input
                        class="form-control form-control-sm"
                        [(ngModel)]="area.area">
                    }
                  </div>
                  <!-- PHONE -->
                  <div class="col-sm-3">
                    <input class="form-control form-control-sm"
                      [(ngModel)]="row.phoneNumber" placeholder="+358 44 123 4567">
                    </div>
                    <!-- TIMES -->
                    <div class="col-sm-3">
                      <input class="form-control form-control-sm"
                        placeholder="00:00-00:00"
                        [(ngModel)]="row.timeRange">
                      </div>
                      <!-- PLUS BUTTON -->
                      <div class="col-sm-1 d-flex align-items-center">
                        @if (j === area.rows.length - 1) {
                          <span
                            (click)="addPhoneRow(i)"
                            style="cursor: pointer; font-size: 20px; user-select: none;">
                            +
                          </span>
                        }
                      </div>
                    </div>
                  }
                </div>
              }
              <div class="form-group mb-3">
                @if (areas.length > 0) {
                  <button class="btn btn-primary mr-2" (click)="saveCallListItems()" [disabled]="!isCallListValid()">
                    <span class="fa fa-floppy-disk"></span>
                    {{ "SAVE" | translate }}
                  </button>
                }
                <button class="btn btn-outline-primary btn-sm" (click)="addArea()">
                  {{ "ADD_AREA" | translate }}
                </button>
              </div>
            </div>
          }
          @if (loading) {
            <div>
              <img
                class="fadeLoader centerLoader logoSmall"
                src="assets/img/loading_logo.svg" />
              </div>
            }